import React, { useEffect, useId } from 'react';
import { useUploadFile } from '../../../hooks/useUploadFile';

interface Props {
  onSubmit: (file: File | null | string) => void;
  label?: string;
  accept?: string;
  children?: React.ReactNode;
  base64?: boolean;
}

export default function ButtonFileUpload({
                                           onSubmit,
                                           accept,
                                           label,
                                           base64 = false,
                                         }: Props) {
  const { handleFileChange, file, convertToBase64, clearState } = useUploadFile();
  const fileInputId = useId();

  useEffect(() => {
    if (file !== null) {
      if (base64)
        convertToBase64(file).then(base64 => {
          onSubmit(base64);
        });
      else
        onSubmit(file);
    } else
      onSubmit('');
  }, [file]);


  return (
    <div>
      {file === null && <>
        <label htmlFor={fileInputId}
               className="flex items-center gap-1.5 h-11 font-semibold text-sm cursor-pointer bg-[#F1F5F9] rounded-md px-4 py-2">
          <img
            src={require('../../../assets/UploadResize.png')}
            className="h-4 w-4"
            alt="Upload"
          />
          {label || 'Carga un archivo desde tu ordenador'}
        </label>

        <div>
          <input
            data-testid="file-upload"
            id={fileInputId}
            type="file"
            accept={accept || ''}
            onChange={handleFileChange}
            className="hidden"
          ></input>
        </div>
      </>
      }


      {
        file !== null &&
        <div className="flex items-center gap-1.5  cursor-pointer border rounded-lg px-2 py-0.5">
          <img
            src={require('../../../assets/filePlus.png')}
            className="h-9 w-9"
            alt="file plus"
          />
          <div className={'text-black font-semibold text-sm leading-5  '}>
            {file.name}
            <br />
            <small className={'text-black font-normal leading-[18px]'}>{file.size / 1024} KB</small>
          </div>

          <img
            src={require('../../../assets/trashRed.png')}
            className="h-9 w-9"
            onClick={clearState}
            alt="trash"
          />
        </div>
      }
    </div>
  );
}
